import React from "react";
import { withStyles } from "@mui/styles";

import Button from "../../components/button/Button";
import ErrorMessage from "../../components/errorMessage/ErrorMessage";
import { Typography } from "@mui/material";

const styles = (theme) => ({
  section: {
    width: "100%",
    backgroundColor: "#fff",
  },
});

function UpdateMemberForm({
  title,
  description,
  buttonText,
  classes,
  payload,
  onSubmit,
  errorMessage,
  submitting,
  successMessage,
}) {
  return (
    <div className={classes.section}>
      {title && (
        <Typography
          variant="h5"
          id="update-member-title"
          sx={{ marginBottom: "10px" }}
        >
          {title}
        </Typography>
      )}
      {description && (
        <Typography sx={{ marginBottom: "10px" }}>{description}</Typography>
      )}
      {!successMessage && (
        <Button
          title={buttonText}
          onClick={() => onSubmit(payload)}
          submitting={submitting}
          style={{ minWidth: "221.328px", marginBottom: "20px" }}
        />
      )}
      {successMessage && (
        <div style={{ color: "#3CC87B" }}>{successMessage}</div>
      )}
      <ErrorMessage message={errorMessage} />
    </div>
  );
}

export default withStyles(styles)(UpdateMemberForm);
